import Spline from "@splinetool/react-spline";
import styled from "styled-components";

export default function App() {
  return (
    <Wrapper>
      <Spline
        className="spline"
        scene="https://prod.spline.design/N0XhYbL9xXK7lBga/scene.splinecode"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-family: "Spline Sans", sans-serif;
  color: white;
  font-size: 16px;
  margin: 0 auto;
  height: 100%;
  overflow: hidden;
  z-index: 11;

  .spline {
    position: absolute;
    margin: 0;
    top: 0;
    width: 1200px;
    height: 1000px;

    @media (max-width: 1024px) {
      right: 0px;
      transform-origin: center;
    }
  }
`;

